import { z } from 'zod';

export const ContactEmailSchema = z.object({
  prename: z.string().min(1).max(200),
  surname: z.string().min(1).max(200),
  email: z.string().email(),
  subject: z.string().min(1).max(300),
  message: z.string().min(1).max(5000),
});

export const SendContactEmailSchema = ContactEmailSchema.extend({
  captchaToken: z.string().min(1),
});
